import { array, number, string, object, boolean } from '@gogame/schemas';

import {
  COUNTRIES,
  SIZES,
  INCLUDE_INTERNATIONAL,
  MULTIPLY_OPTIONS,
} from './constants';

export const validationSchema = object({
  [COUNTRIES]: array(number()).required('Countries  is required'),
  [MULTIPLY_OPTIONS]: object({
    [SIZES]: string().required('Size  is required'),
    [INCLUDE_INTERNATIONAL]: boolean(),
  }),
});
